import { IPlotArea } from './IPlotArea';
import { ResizableBase } from './ResizableBase';
import { IResizable } from './IResizable';
import { ILogger, LoggerFactory, GuidHelper } from '../../helpers/helpers';

export class PlotArea extends ResizableBase implements IPlotArea {

    private _clipPathId: string;
    private _width: number;
    private _height: number;
    private _logger: ILogger;

    constructor(container: d3.Selection<any>, width: number, height: number) {
        super(container, 'plot-area');
        try {
            this._logger = LoggerFactory.getLogger('WideTech.Charting.plotArea', false, 2);
            this.createPlotArea(container, width, height);
        } catch (e) {
            this._logger.error(e);
        }
    }

    private createPlotArea(container: d3.Selection<any>, width: number, height: number): d3.Selection<any> {
        //TODO hidden dependency
        this._clipPathId = GuidHelper.getGuid();
        const plotAreaGroup = this.group();
        this._width = width;
        this._height = height;
        const clipPath = plotAreaGroup
            .append('clipPath')
            .attr({
                'id': this._clipPathId
            });
        clipPath
            .append('rect')
            .classed('clip-path-rectangle', true)
            .attr({
                'x': 0,
                'y': 0,
                width: width,
                height: height
            });
        plotAreaGroup
            .append('rect')
            .classed('plot-area-rectangle', true)
            .attr({
                'x': 0,
                'y': 0,
                'width': width,
                'height': height
            });
        return plotAreaGroup;
    }

    resizeFunction() {
        const self = this;
        return (w: number, h: number) => {
            self.resize(w, h, self);
            self._width = w;
            self._height = h;
        };
    }

    resize(width: number, height: number, obj: IResizable): void {
        obj.group().select('.plot-area-rectangle')
            .attr({
                'width': isNaN(width) || width < 0 ? 0 : width,
                'height': isNaN(height) || height < 0 ? 0 : height
            });
        obj.group().select('.clip-path-rectangle')
            .attr({
                'width': isNaN(width) || width < 0 ? 0 : width,
                'height': isNaN(height) || width < 0 ? 0 : height
            });
    }

    clipPathId(): string {
        return this._clipPathId;
    }

    width() {
        return this._width;
    }

    height() {
        return this._height;
    }
}
